import { tv } from 'tailwind-variants';

export { default as Dialog } from './Dialog.vue';

export const dialogVariants = tv({
    slots: {
        overlay: [
            'fixed inset-0 z-modal bg-black/40',
            'data-[state=open]:animate-in data-[state=open]:fade-in-0',
            'data-[state=closed]:animate-out data-[state=closed]:fade-out-0',
        ],
        content: [
            'fixed z-modal flex flex-col rounded-lg bg-white shadow-xl outline-none',
            'inset-x-4 bottom-4 max-h-[calc(100vh-2rem)]',
            'sm:inset-x-auto sm:bottom-auto sm:left-1/2 sm:top-1/2 sm:max-h-[calc(100vh-4rem)] sm:w-full sm:-translate-x-1/2 sm:-translate-y-1/2',
            'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
            'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
            'duration-150',
        ],
        header: 'shrink-0 border-b border-gray-200 px-4 py-4 pr-14 sm:px-5 sm:pr-14',
        title: 'text-lg font-semibold text-gray-900',
        description: 'mt-1 text-sm text-gray-600',
        body: 'flex-1 overflow-y-auto px-4 py-4 sm:px-5',
        footer: 'flex shrink-0 flex-col-reverse gap-3 border-t border-gray-200 px-4 py-3 sm:flex-row sm:justify-end sm:px-5',
        close: 'absolute right-3 top-3 cursor-pointer rounded-lg bg-white text-gray-600 transition-colors hover:text-gray-900 hover:bg-gray-50 p-1 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
    },
    variants: {
        size: {
            sm: { content: 'sm:max-w-md' },
            md: { content: 'sm:max-w-xl' },
            lg: { content: 'sm:max-w-3xl' },
            xl: { content: 'sm:max-w-5xl' },
        },
    },
    defaultVariants: { size: 'md' },
});
